/**
 * Cấu hình app — đọc từ .env (build-time):
 *   - .env.development: dev local
 *   - .env.production:  build deploy
 *
 * Branding fields (logo, tên trường, support contacts) cho phép reskin nhanh
 * khi deploy cho institution khác (HAU, SGU, DHCNTT...) mà không sửa code.
 */
const apiOrigin = process.env.REACT_APP_API_URL || "http://localhost:5100";

export const appConst = {
    /** Origin (không slash cuối) — dùng cho SignalR hub URL etc. */
    apiOrigin,
    /** Base URL cho REST API — đã include `/api`. */
    baseApiURL: `${apiOrigin}/api`,

    /**
     * Mã trường (multi-tenant) — set theo .env của từng deployment, khớp AppSettings:School:Code backend.
     * Dùng để bật/tắt UI đặc thù theo trường (vd: ICTU ẩn 2 cột Nhóm chung/Nhóm tự chọn).
     * Không set = trường mặc định (HVTC) → bật full feature.
     */
    schoolCode: process.env.REACT_APP_SCHOOL_CODE || "",

    /**
     * Đăng nhập OAuth — bật riêng từng provider (.env theo trường).
     * onlyOAuth=true: ẩn luôn form đăng nhập bằng mã SV, chỉ còn nút Google/Microsoft
     * (chỉ có hiệu lực khi đã bật ít nhất 1 provider — tránh khoá sạch đường đăng nhập).
     */
    oauth: {
        google: process.env.REACT_APP_OAUTH_GOOGLE === "true",
        microsoft: process.env.REACT_APP_OAUTH_MICROSOFT === "true",
        onlyOAuth: process.env.REACT_APP_OAUTH_ONLY === "true",
    },

    /**
     * Đăng nhập SSO qua cổng đăng nhập tập trung (OIDC) — bật theo .env của từng trường.
     * unit:
     *   ""        → tắt SSO (chỉ login mã SV + OAuth Google/MS như cũ)
     *   "vnpt"    → SSO VNPT (Authorization Code + PKCE thủ công)
     *   "namviet" → SSO Nam Việt / ESSOFT (OIDC chuẩn qua thư viện oidc-react)
     * Khi bật SSO: ẩn form mã SV/mật khẩu (trừ khi /login?masv=031298). Khớp backend Sso:Unit.
     * Mirror cấu hình MARKMAN (REACT_APP_OIDC_*).
     */
    sso: {
        unit: (process.env.REACT_APP_OIDC_UNIT || "").toLowerCase(),
        authority: process.env.REACT_APP_OIDC_AUTHORITY || "",
        clientId: process.env.REACT_APP_OIDC_CLIENT_ID || "",
        clientSecret: process.env.REACT_APP_OIDC_CLIENT_SECRET || "",
        redirectUri: process.env.REACT_APP_OIDC_REDIRECT_URI || "",
        scope: process.env.REACT_APP_OIDC_SCOPE || "openid profile email",
        logout: process.env.REACT_APP_OIDC_LOGOUT || "",
    },

    /**
     * Trang chủ portal chính (vd https://main.hvtc.edu.vn). Khi set → menu "Đổi mật khẩu" KHÔNG
     * mở dialog đổi mật khẩu nội bộ mà redirect sang {URL_PAGE_MAIN}/ResetPassword.html?token=...
     * (giống MARKMAN — đổi mật khẩu tập trung ở portal chính). Rỗng → dùng dialog nội bộ như cũ.
     */
    urlPageMain: process.env.REACT_APP_URL_PAGE_MAIN || "",

    /**
     * Chính sách mật khẩu (buộc đổi mật khẩu yếu) — mirror backend AppSettings:PasswordPolicy.
     * minLength PHẢI khớp PasswordPolicy:MinLength của backend để checklist/validate FE không lệch
     * với chốt chặn server. Không set = 8 (default backend).
     */
    passwordPolicy: {
        minLength: Number(process.env.REACT_APP_PASSWORD_MIN_LENGTH) || 8,
    },

    branding: {
        webName: process.env.REACT_APP_WEB_NAME || "Học viện Tài Chính",
        tagline: process.env.REACT_APP_TAGLINE || "Cổng đăng ký tín chỉ",
        /** Logo HVTC chính thức từ SSO endpoint — fallback default nếu env không set. */
        logoUrl:
            process.env.REACT_APP_LOGO_URL ||
            "https://main.hvtc.edu.vn/images/logo.png",
        instructionsLink: process.env.REACT_APP_INSTRUCTIONS_LINK || "",
        copyright: process.env.REACT_APP_COPYRIGHT || "© 2026 All Rights Reserved",
    },

    contact: {
        address: process.env.REACT_APP_ADDRESS || "",
        email: process.env.REACT_APP_EMAIL || "",
        hotline: process.env.REACT_APP_HOTLINE || "",
        fax: process.env.REACT_APP_FAX || "",
        website: process.env.REACT_APP_WEBSITE || "",
    },

    support: {
        daoTao: {
            name: process.env.REACT_APP_SUPPORT_DAOTAO_NAME || "Ban Quản lý đào tạo",
            email: process.env.REACT_APP_SUPPORT_DAOTAO_EMAIL || "",
            phone: process.env.REACT_APP_SUPPORT_DAOTAO_PHONE || "",
        },
        tech: [
            {
                name: process.env.REACT_APP_SUPPORT_TECH_1_NAME || "",
                phone: process.env.REACT_APP_SUPPORT_TECH_1_PHONE || "",
            },
            {
                name: process.env.REACT_APP_SUPPORT_TECH_2_NAME || "",
                phone: process.env.REACT_APP_SUPPORT_TECH_2_PHONE || "",
            },
            {
                name: process.env.REACT_APP_SUPPORT_TECH_3_NAME || "",
                phone: process.env.REACT_APP_SUPPORT_TECH_3_PHONE || "",
            },
        ].filter(t => t.name),
    },
};
